var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "list-meta__item",
      class: {
        "list-meta__item--name": _vm.isName,
        "w-full": _vm.fullWidth,
      },
    },
    [
      _vm.icon ? _c("i", { class: `fa fa-${_vm.icon} fa-fw` }) : _vm._e(),
      _vm._v(" "),
      _vm.label
        ? _c("span", { staticClass: "list-meta__label" }, [_vm._t("key")], 2)
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "list-meta__text" }, [_vm._t("default")], 2),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }